import React, { useReducer, createContext } from "react";
import { deviceListData, dietPlans, healthConditions } from './staticData';

export const AppContext = createContext();

const initialState = {
    user: {},
    doctorList: [],
    consultationList: [],
    loading: true,
    deviceList: deviceListData,
    dietPlans: dietPlans,
    healthConditions: healthConditions,
    assessment: {
        planType: '',
        preferredCuisine: '',
        dietaryPreference: '',
        allergies:[],
        address:{},
    },
    riskAssessment: {
        diabetes: '',
        bloodPressure: '',
        physicallyActive: '',
        gestationalDiabetes:'',
        bmi: ''
    },
    couponCodeDietPlan: {},
    infoScreen: {},
    existingDietplan: {},
    timerDisplay: false,
    activatePlan:false
};

const reducer = (state, action) => {
    switch (action.type) {
        case "TIMER_DISPLAY":
            return {
                ...state,
                timerDisplay: action.payload
            };
        case "USER_DETAILS":
            return {
                ...state,
                user: { ...state.user, ...action.payload }
            };
        case "LIST_DOCTOR":
            return {
                ...state,
                doctorList: [ ...action.payload ]
            };
        case "LIST_CONSULTATION":
            return {
                ...state,
                consultationList: [ ...action.payload ]
            };
        case "HEALTH_CONDITIONS":
            return {
                ...state,
                healthConditions: [ ...action.payload ]
            };
        case "ASSESSMENT":
            return {
                ...state,
                assessment: { ...state.assessment, ...action.payload }
            };
        case "RISK_ASSESSMENT":
            return {
                ...state,
                riskAssessment: { ...state.riskAssessment, ...action.payload }
            };
        case "COUPON_CODE_DIETPLAN":
            return {
                ...state,
                couponCodeDietPlan: { ...state.couponCodeDietPlan, ...action.payload }
            };
        case "INFO_SCREEN":
                return {
                    ...state,
                    infoScreen: { ...state.infoScreen, ...action.payload }
                };
        case "LOADING":
            return {
                ...state,
                loading: action.payload
            }
        case "EXISTING_DIETPLAN":
            return {
                ...state,
                existingDietplan: { ...state.existingDietplan, ...action.payload }
            }

        case "ACTIVATE_PLAN":
            return {
                ...state,
                activatePlan: {  ...action.payload }
            }

        default:
            throw new Error();
    }
};

export const AppContextProvider = (props) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return (
        <AppContext.Provider value={[state, dispatch]}>
            {props.children}
        </AppContext.Provider>
    )
}